import React from 'react';
import Avatar from "@/components/Avatar.tsx";

const Cmp = React.lazy(()=>import('./AvatarWithUploader_Internal.tsx'));

export default function AvatarWithUploader(props){
    return <React.Suspense fallback={<Avatar {...props}/>}>
        <Cmp {...props} />
    </React.Suspense>
}



